module.exports = __webpack_public_path__ + "files/78f2f038514b3c594a9a4e99db738da3.png";